<template>
  <label class="cordel-input-container">
    <font-awesome-icon
      v-if="icon"
      :icon="icon"
      class="cordel-input-icon"
    />

    <input
      :id="name"
      ref="input"

      :name="name"

      :class="classes"

      :disabled="disabled"

      :placeholder="placeholder"

      :type="type"
      :maxlength="maxlength"

      :value="value"

      @input="input"
      @blur="blur"
      @focus="focus"
      @keydown="keydown"
    >
  </label>
</template>

<script>
  import monetize from '@sdk/helpers/formatters/monetize';
  import patternize from '@sdk/helpers/formatters/patternize';
  // eslint-disable-next-line import/no-extraneous-dependencies
  import { percentize } from '@/helpers/filters';

  const SIZES = ['small', 'medium'];

  export default {
    name: 'CordelInput',
    props: {
      name: {
        type: String,
        default: '',
      },
      value: {
        type: [String, Number],
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      icon: {
        type: String,
        default: null,
      },
      size: {
        type: String,
        default: SIZES[1],
        validator(value) {
          return SIZES.includes(value);
        },
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      mask: {
        type: Object,
        default() {
          return {};
        },
      },
      errors: {
        type: Array,
        default() {
          return [];
        },
      },
      typed: {
        type: String,
        default: null,
      },
    },
    computed: {
      classes() {
        const classes = [
          'cordel-input',
          `size--${this.size}`,
        ];

        if (this.errors.length) {
          classes.push('state--error');
        }

        if (this.disabled) {
          classes.push('state--disabled');
        }

        if (this.loading) {
          classes.push('state--loading');
        }

        if (this.loading) {
          classes.push('state--loading');
        }

        if (this.icon) {
          classes.push('variant--iconed');
        }

        return classes;
      },
      patternized() {
        return this.mask && this.mask.type === 'patternize';
      },
      monetized() {
        return this.mask && this.mask.type === 'monetize';
      },
      type() {
        if (this.typed === 'password') {
          return 'password';
        }

        return (this.patternized || this.monetized) ? 'tel' : 'text';
      },
      maxlength() {
        if (!this.patternized) {
          return null;
        }

        const {
          format,
          bigFormat,
        } = this.mask;

        return (bigFormat || format).length;
      },
    },
    methods: {
      input(e) {
        let updated;

        if (this.mask && this.mask.type) {
          switch (this.mask.type) {
            case 'patternize':
              updated = patternize(e.target.value, this.mask);
              break;
            case 'monetize':
              updated = monetize(e.target.value, this.mask);
              break;
            case 'percentize':
              updated = percentize(e.target.value, this.mask);
              break;
            default:
              updated = e.target.value;
          }
        } else {
          updated = e.target.value;
        }

        this.$emit('input', updated);
      },
      blur(e) {
        this.$emit('blur', e);
        this.$emit('change', { target: { value: this.value } });
      },
      keydown(e) {
        this.$emit('keydown', e);
      },
      focus(e) {
        this.$emit('focus', e);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-input-container {
    display: block;
    position: relative;
  }

  .cordel-input {
    @include cordel-input-reset;

    background-color: var(--cordel-color-neutral-lighter);
    border-radius: var(--cordel-border-radius-small);
    box-shadow: 0 0 0 var(--cordel-border-width-soft) var(--cordel-color-neutral-primary);
    padding: var(--cordel-spacing-xxxs) var(--cordel-spacing-xs);
    width: 100%;

    &::placeholder {
      color: var(--cordel-color-neutral-primary);
    }

    &:focus {
      box-shadow: 0 0 0 var(--cordel-border-width-thin) var(--cordel-color-highlight-primary);
    }
  }

  .size--small {
    padding: var(--cordel-spacing-nano) var(--cordel-spacing-micro);
  }

  .state--error {
    box-shadow: 0 0 0 var(--cordel-border-width-thin) var(--cordel-color-alert-danger);
  }

  .state--disabled {
    background-color: transparent;
    box-shadow: 0 0 0 var(--cordel-border-width-soft) var(--cordel-color-neutral-primary);
    color: var(--cordel-color-neutral-primary);
    cursor: not-allowed;
  }

  .state--loading {
    box-shadow: 0 0 0 var(--cordel-border-width-soft) var(--cordel-color-neutral-primary);
    color: var(--cordel-color-neutral-primary);
    cursor: progress;
  }

  .variant--iconed {
    padding-left: calc(
      var(--cordel-spacing-xs) + var(--cordel-font-size-m) + var(--cordel-spacing-xs)
    );
  }

  .cordel-input-icon {
    color: var(--cordel-color-neutral-primary);
    left: var(--cordel-spacing-xs);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
</style>
